import { DATA_REQUEST_ASYNC, INSPECTED_COUNT_REQUEST_ASYNC } from './constants'

const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

const fetchInspectedCount = () => ({ type: INSPECTED_COUNT_REQUEST_ASYNC.INITIATE })
export const fetchInspectedCountSuccess = (data) => ({
  type: INSPECTED_COUNT_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchInspectedCountError = (error) => ({
  type: INSPECTED_COUNT_REQUEST_ASYNC.ERROR,
  error,
})
const fetchInspectedCountCancel = () => ({ type: INSPECTED_COUNT_REQUEST_ASYNC.CANCEL })

export default {
  // to props
  fetchData,
  fetchDataCancel,
  fetchInspectedCount,
  fetchInspectedCountCancel,
}
